import Swiper from 'swiper';
import {Navigation, Pagination, EffectFade, Autoplay } from 'swiper/modules';
import { fadeIn, fadeOut } from '@soinproduction/kit/src/functions/customFunctions';

document.addEventListener("DOMContentLoaded", function () {
	const teamSlider = document.querySelector('.section-team__slider');
	const levelsSlider = document.querySelector('.section-levels__slider');
	const completedSlider = document.querySelector('.section-completed__slider');
	const portfolioSlider = document.querySelector('.section-portfolio__slider');
	const buildingdSlider = document.querySelector('.section-building__slider');
	const aboutSlider = document.querySelectorAll('.section-about__slider');
	const additionalSlider = document.querySelectorAll('.single-project__slider');
	const otherSlider = document.querySelectorAll('.other-card__slider');

	if (teamSlider) {
		let teamSwiper = null;

		function initTeamSwiper() {
			const swiperContainer = teamSlider?.querySelector('.swiper-container');

			if (window.innerWidth <= 1025) {
				if (swiperContainer && !teamSwiper) {
					teamSwiper = new Swiper(swiperContainer, {
						speed: 1500,
						spaceBetween: 24,
						loop: true,
						breakpoints: {
							320: {
								slidesPerView: 1.15,
							},
							576: {
								slidesPerView: 1.75,
							},
							768: {
								slidesPerView: 2.5,
							}
						}
					});
				}
			} else {
				// Уничтожаем слайдер при уменьшении ширины
				if (teamSwiper) {
					teamSwiper.destroy(true, true);
					teamSwiper = null;
				}
			}
		}

		// Инициализация при загрузке
		initTeamSwiper();

		// Обработка ресайза
		window.addEventListener('resize', () => {
			initTeamSwiper();
		});
	}

	if (levelsSlider) {
		let levelsSwiper = null;

		function initLevelsSwiper() {
			const swiperContainer = levelsSlider?.querySelector('.swiper-container');

			if (window.innerWidth <= 1441) {
				if (swiperContainer && !levelsSwiper) {
					levelsSwiper = new Swiper(swiperContainer, {
						speed: 1500,
						// loop: true,
						breakpoints: {
							320: {
								slidesPerView: 1.15,
								spaceBetween: 14,
							},
							576: {
								slidesPerView: 1.75,
								spaceBetween: 16,
							},
							768: {
								slidesPerView: 2.15,
								spaceBetween: 24,
							},
							1024: {
								slidesPerView: 2.15,
								spaceBetween: 24,
							}
						}
					});
				}
			} else {
				// Уничтожаем слайдер при уменьшении ширины
				if (levelsSwiper) {
					levelsSwiper.destroy(true, true);
					levelsSwiper = null;
				}
			}
		}

		// Инициализация при загрузке
		initLevelsSwiper();

		// Обработка ресайза
		window.addEventListener('resize', () => {
			initLevelsSwiper();
		});
	}

	if (aboutSlider) {
		aboutSlider.forEach((slider) => {
			const swiperContainer = slider.querySelector('.swiper-container');

			if (swiperContainer) {
				new Swiper(swiperContainer, {
					modules: [Navigation, Pagination, EffectFade], // подключили fade
					slidesPerView: 1,
					speed: 1500,
					effect: 'fade', // эффект затухания
					fadeEffect: {
						crossFade: true // для плавного перехода
					},
					loop: true,
					watchOverflow: true,
					watchSlidesProgress: true,
					slideVisibleClass: 'swiper-slide-visible',
					navigation: {
						nextEl: slider.querySelector('.slider-btn.next'),
						prevEl: slider.querySelector('.slider-btn.prev'),
					},
					pagination: {
						el: slider.querySelector('.swiper-pagination'),
						clickable: true,
						type: 'bullets',
					},
				});
			}
		});
	}

	if (additionalSlider) {
		const staticProjectContentContainer = document.querySelector('.single-project__content');
		
		additionalSlider.forEach((slider) => {
			const swiperContainer = slider.querySelector('.swiper-container');

			if (swiperContainer) {
				const test = new Swiper(swiperContainer, {
					modules: [Navigation, Pagination, EffectFade, Autoplay],
					slidesPerView: 1,
					speed: 1500,
					effect: 'fade',
					fadeEffect: {
						crossFade: true
					},
					loop: true,
					watchOverflow: true,
					watchSlidesProgress: true,
					slideVisibleClass: 'swiper-slide-visible',
					navigation: {
						nextEl: slider.querySelector('.slider-btn.next'),
						prevEl: slider.querySelector('.slider-btn.prev'),
					},
					pagination: {
						el: slider.querySelector('.swiper-pagination'),
						clickable: true,
						type: 'bullets',
					},
					autoplay: {
						delay: 3500,
						disableOnInteraction: false,
					},
				});

				let isContentVisible = test.realIndex === 0;

				function updateNoBefore() {
					test.slides.forEach((slide) => {
						// сначала всем ставим no-before
						slide.classList.add('no-before');
					});
					// убираем только у слайда, соответствующего realIndex
					const currentSlide = test.slides[test.activeIndex];
					if (test.realIndex === 0 && currentSlide) {
						currentSlide.classList.remove('no-before');
					}
				}

				// Сразу после инициализации
				updateNoBefore();

				test.on('slideChange', function () {
					// Логика для контента
					if (test.realIndex === 0 && !isContentVisible) {
						fadeIn(staticProjectContentContainer, 400, 'flex');
						isContentVisible = true;
					} else if (test.realIndex !== 0 && isContentVisible) {
						fadeOut(staticProjectContentContainer, 400);
						isContentVisible = false;
					}

					// Обновляем классы
					updateNoBefore();
				});
			}
		});
	}


	if (completedSlider) {
		const swiperContainer = completedSlider.querySelector('.swiper-container');

		if (swiperContainer) {
			new Swiper(swiperContainer, {
				modules: [Navigation, Autoplay],
				slidesPerView: 3,
				speed: 1800,
				spaceBetween: 24,
				loop: true,
				centeredSlides: true,
				watchOverflow: true,
				watchSlidesProgress: true,
                slideVisibleClass: 'swiper-slide-visible',
				navigation: {
					nextEl: completedSlider.querySelector('.completed-next'),
					prevEl: completedSlider.querySelector('.completed-prev'),
				},
				breakpoints: {
					320: {
						slidesPerView: 1.05,
						spaceBetween: 12,
						centeredSlides: false,
					},
					768: {
						slidesPerView: 2.15,
						spaceBetween: 24,
						centeredSlides: false,
					},
					1025: {
						slidesPerView: 2.5,
					},
					1441: {
						slidesPerView: 2.75,
					},
					1640: {
						slidesPerView: 3,
					}
				},
				autoplay: {
					delay: 1500,
					disableOnInteraction: false,
				},
			});
		}
	}

	if (buildingdSlider) {
		const swiperContainer = buildingdSlider.querySelector('.swiper-container');

		if (swiperContainer) {
			new Swiper(swiperContainer, {
				modules: [Navigation, Autoplay],
				speed: 600,
				loop: true,
				watchOverflow: true,
                watchSlidesProgress: true,
                slideVisibleClass: 'swiper-slide-visible',
				navigation: {
					nextEl: buildingdSlider.querySelector('.slider-btn.next'),
					prevEl: buildingdSlider.querySelector('.slider-btn.prev'),
				},
				breakpoints: {
					320: {
						slidesPerView: 1.15,
						spaceBetween: 10,
					},
					768: {
						slidesPerView: 2,
						spaceBetween: 12,
					},
					1024: {
						slidesPerView: 2,
						spaceBetween: 24,
					},
				},
				autoplay: {
					delay: 2500,
					disableOnInteraction: false,
				},
			});
		}
	}
	
	if (portfolioSlider) {
		const getSwiperContainer = (tabIndex) =>
			portfolioSlider.querySelector(`.tabs-content__item[data-tab-content="${tabIndex}"] .section-portfolio__slider > .swiper-container`);

		// Храни ссылку на Swiper, чтобы не переинициализировать
		let currentSwiper = null;


		// Инициализация для первой активной вкладки
		const initialContainer = portfolioSlider.querySelector('.tabs-content__item.active .section-portfolio__slider > .swiper-container');
		if (initialContainer) {
			currentSwiper = new Swiper(initialContainer, {
				modules: [Navigation, Autoplay],
				slidesPerView: 3,
				speed: 1800,
				spaceBetween: 24,
				loop: true,
				centeredSlides: true,
				watchOverflow: true,
				watchSlidesProgress: true,
				slideVisibleClass: 'swiper-slide-visible',
				navigation: {
					nextEl: portfolioSlider.querySelector('.portfolio-next'),
					prevEl: portfolioSlider.querySelector('.portfolio-prev'),
				},
				breakpoints: {
					320: {
						slidesPerView: 1.05,
						spaceBetween: 12,
						centeredSlides: false,
					},
					768: {
						slidesPerView: 2.15,
						spaceBetween: 24,
						centeredSlides: false,
					},
					1025: {
						slidesPerView: 2.25,
					},
					1441: {
						slidesPerView: 2.75,
					},
					1640: {
						slidesPerView: 3,
					}
				},
				autoplay: {
					delay: 1500,
					disableOnInteraction: false,
				},
			});
		}

		// При клике по табу
		document.querySelectorAll('.section-portfolio .tabs-nav__btn').forEach(tabBtn => {
			tabBtn.addEventListener('click', function (e) {
				e.preventDefault();

				const tabIndex = this.dataset.tab;

				// Найти активный контейнер
				const tabItem = document.querySelector(`.section-portfolio .tabs-content__item[data-tab-content="${tabIndex}"]`);
				const targetContainer = tabItem?.querySelector('.section-portfolio__slider > .swiper-container');
				const nextEl = tabItem?.querySelector('.portfolio-next');
				const prevEl = tabItem?.querySelector('.portfolio-prev');

				if (!targetContainer || !nextEl || !prevEl) return;

				// Удаляем старый слайдер
				if (currentSwiper) {
					currentSwiper.destroy(true, true);
				}

				// Инициализируем Swiper для нового таба
				currentSwiper = new Swiper(targetContainer, {
					modules: [Navigation, Autoplay],
					slidesPerView: 3,
					speed: 1800,
					spaceBetween: 24,
					loop: true,
					centeredSlides: true,
					watchOverflow: true,
					watchSlidesProgress: true,
					slideVisibleClass: 'swiper-slide-visible',
					navigation: {
						nextEl: nextEl,
						prevEl: prevEl,
					},
					breakpoints: {
						320: {
							slidesPerView: 1.05,
							spaceBetween: 12,
							centeredSlides: false,
						},
						768: {
							slidesPerView: 2.15,
							spaceBetween: 24,
							centeredSlides: false,
						},
						1025: {
							slidesPerView: 2.5,
							initialSlide: 1,
						},
						1441: {
							initialSlide: 1,
							slidesPerView: 2.75,
						},
						1640: {
							slidesPerView: 3,
							initialSlide: 1,
						}
					},
					autoplay: {
						delay: 1500,
						disableOnInteraction: false,
					},
				});
			});
		});
	}

	if (otherSlider) {
		otherSlider.forEach((slider) => {
			const swiperContainer = slider.querySelector('.swiper-container');

			if (swiperContainer) {
					new Swiper(swiperContainer, {
					modules: [Navigation, Pagination, EffectFade],
					slidesPerView: 1,
					speed: 1500,
					effect: 'fade',
					fadeEffect: {
						crossFade: true,
					},
					loop: true,
					watchOverflow: true,
					watchSlidesProgress: true,
					slideVisibleClass: 'swiper-slide-visible',
					navigation: {
						nextEl: slider.querySelector('.slider-btn.next'),
						prevEl: slider.querySelector('.slider-btn.prev'),
					},
					pagination: {
						el: slider.querySelector('.swiper-pagination'),
						clickable: true,
						type: 'bullets',
					},
				});
			}
		});
	}
});


let swiperInstances = [];

// Универсальная инициализация карточек проектов
export function initSliders() {
	// Удаляем старые Swiper-экземпляры
	swiperInstances.forEach(swiper => swiper?.destroy?.(true, true));
	swiperInstances = [];

	const defaultSliders = document.querySelectorAll('.project-card__slider');

	defaultSliders.forEach((slider) => {
		const swiperContainer = slider.querySelector('.swiper-container');

		if (swiperContainer) {
			const swiper = new Swiper(swiperContainer, {
				modules: [Navigation, Pagination, EffectFade],
				slidesPerView: 1,
				speed: 1500,
				effect: 'fade',
				fadeEffect: {
					crossFade: true,
				},
				loop: true,
				watchOverflow: true,
				watchSlidesProgress: true,
				slideVisibleClass: 'swiper-slide-visible',
				navigation: {
					nextEl: slider.querySelector('.slider-btn.next'),
					prevEl: slider.querySelector('.slider-btn.prev'),
				},
				pagination: {
					el: slider.querySelector('.swiper-pagination'),
					clickable: true,
					type: 'bullets',
				},
			});

			swiperInstances.push(swiper);
		}
	});
}